module.exports = __webpack_public_path__ + "img/clear_up.83be447a.png";